export const selectCurrentModal = ({ core: { currentModal } }) => currentModal;
export const selectCurrentModalData = ({ core: { currentModalData } }) => currentModalData;

export const selectListTransferPrepare = ({ core: { listTransferPrepare } }) =>
  listTransferPrepare;

export const selectListTransferPointSystemPrompt = ({ core: { listTransferPointSystemPrompt } }) =>
  listTransferPointSystemPrompt;

export const selectCardTransferPointSystemPrompt = ({ core: { cardTransferPointSystemPrompt } }) =>
  cardTransferPointSystemPrompt;

export const selectCardTransferStatus = ({ core: { cardTransferStatus } }) => cardTransferStatus;

export default {
  selectCurrentModal,
  selectCurrentModalData,
  selectListTransferPrepare,
  selectListTransferPointSystemPrompt,
  selectCardTransferPointSystemPrompt,
  selectCardTransferStatus,
};
